import { combineReducers } from 'redux'
import counter from './counter'
import rootReducers from './rootReducers';

export default combineReducers({
  rootReducers,
  counter,
})
